import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { UserService } from '../../../@core/data/users.service';

import { AnalyticsService } from '../../../@core/utils/analytics.service';
import { AuthService } from "../../../shared/services/auth.service";
import { Router } from "@angular/router";

import { UserModel } from "../../../shared/models/user.model";
import {skip} from 'rxjs/operators';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {


  @Input() position = 'normal';

  user: UserModel;

  userPicture: string = "assets/images/user.png";

  userMenu = [{ title: 'Log out' }];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private userService: UserService,
              private analyticsService: AnalyticsService,
              private authService: AuthService,
              private router: Router) {
  }

  ngOnInit() {
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.menuService.onItemClick().pipe(skip(1)).subscribe((item: any) => {
        if (item.item.title === 'Log out') {
          this.authService.logout();
          this.router.navigate(['/auth/login']);
        }
      });
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');
    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }
}
